export default {
  colors: {
    text: '#8258FA',
    background: '#F8E0F7',
    modes: {
      dark: {
        text: '#FC6822',
        background: '#3F3A3E',
      },
    },
  },
};
